import { PartialShipmentManifestDetails } from "../PartialShipmentManifestDetails";
import { DataSource, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentManifestCreationSlideout extends Layout {
    labelManifestDetails: Label;
    labelOrders: Label;
    layoutPartialShipmentManifestDetails: PartialShipmentManifestDetails;
    sourcePartialShipmentPlanningCreateManifest: DataSource;
    textboxDescription: Textbox;
}
